module.exports = __webpack_public_path__ + "img/writing2.bcb621b.jpg";